export const handleArrowClick = (direction, items, activeIndex, onClickNavigate) => {
    const dir = direction === 'right' ? 1 : -1;
    const total = items.length;
    let newIndex = activeIndex;
    for (let i = 0; i < total; i++) {
        newIndex = (newIndex + dir + total) % total;
        if (!items[newIndex]?.disabled) {
            onClickNavigate(newIndex);
            break;
        }
    }
};
//# sourceMappingURL=handle-arrow-click.js.map